import { useMap } from "react-leaflet";
import { useState } from "@wordpress/element";

export default function ComponentResize() {
	const map = useMap()
	const [invalidated, setInvalidated] = useState( false )
	if ( ! invalidated ) {
		setInvalidated( true );
		setTimeout( () => {
			map.invalidateSize()
		}, 0 )
	}

	return null
}
